export const SOCKET_EVENTS = Object.freeze({
  TUTOR_SIGNAL: 'tutor-signal',
  LEGACY_TUTOR_SIGNAL: 'totur-signal',
  STUDENT_SIGNAL: 'student-signal',
  WHITEBOARD_TUTOR_SIGNAL: 'white-board-tutor-signal',
  LEGACY_WHITEBOARD_TUTOR_SIGNAL: 'white-board-totur-signal',
  SCREEN_SHARING_TUTOR_SIGNAL: 'screen-sharing-tutor-signal',
  LEGACY_SCREEN_SHARING_TUTOR_SIGNAL: 'screen-sharing-totur-signal',
});
